import React from 'react';

import ArticleListing from '../ArticleListing/ArticleListing';
import Section, { themes } from '../UI/Section/Section';

const ArticleSection = ({ heading, sectionProps, nodes, ...other }) => {
  return !!nodes.length ? (
    <Section
      theme={themes.TAN_OFFSET}
      heading={heading || `From the **Prime Health Journal**`}
      {...sectionProps}
    >
      <ArticleListing cols={{ md: 4 }} nodes={nodes} {...other} />
    </Section>
  ) : null;
};

export default ArticleSection;
